export default __webpack_public_path__ + "static/media/din2p-1.1ce6025d.png";